import { forwardRef, type Ref, type SVGProps } from "react";

function SvgLocked(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M14.7 9V6a2.7 2.7 0 0 0-5.4 0v3zm-7.27 1.3c-1.135 0-2.13.964-2.13 2.246v5.908c0 1.282.995 2.246 2.13 2.246h9.142c1.135 0 2.13-.964 2.13-2.246v-5.908c0-1.282-.995-2.246-2.13-2.246zM12 13.5a.65.65 0 0 1 .65.65v3.35h-1.3v-3.35a.65.65 0 0 1 .65-.65M16.571 9C18.465 9 20 10.588 20 12.546v5.908C20 20.412 18.465 22 16.571 22H7.43l-.177-.005C5.44 21.9 4 20.351 4 18.455v-5.91C4 10.65 5.44 9.1 7.252 9.006L7.429 9H8V6a4 4 0 1 1 8 0v3z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgLocked);
export default ForwardRef;
